import {Form, FormRenderProps, FormElement, Field, FieldRenderProps} from "@progress/kendo-react-form"
import {Popup} from "@progress/kendo-react-popup"
import {createRef, useCallback, useEffect, useRef, useState} from "react"
import {fetchSearchedVehicleDetail, setResetVehicleSearchForm} from "../../containers/App/appSlice"
import {useAppDispatch} from "../../store"
import RecentBookingsList from "./RecentBookingsList"
import MotHistoryList from "./MotHistoryList"
import WeeklyUtilizationChart from "./WeeklyUtilizationChart"
import {Input, InputChangeEvent} from "@progress/kendo-react-inputs"

const TopSearchTextField = () => {
    const dispatch = useAppDispatch()

    const [vehicleRegNo, setvehicleRegNo] = useState("")
    const [show, setShow] = useState(false)

    const anchor = useRef<any>()

    const blurTimeoutRef = useRef<any>()

    const vehRegRef = createRef<any>()

    const onOpenSchPopover = () => {
        vehRegRef.current.focus()
    }

    const onCloseSchPopover = () => {
        setvehicleRegNo("")

        dispatch(setResetVehicleSearchForm())
    }

    const onFocusSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
    }

    const onBlurSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
        blurTimeoutRef.current = setTimeout(onBlurTimeout, 100)
    }

    const onBlurTimeout = () => {
        setShow(false)
    }

    const focusOnRegField = () => {
        vehRegRef.current.focus()
    }

    useEffect(() => {
        if (vehicleRegNo.length > 0) {
            focusOnRegField()
        }
    }, [vehicleRegNo])

    const searchHandler = (e: any) => {
        var regNumber = e.vehicleSearch.replace(/\s/g, "").toUpperCase()
        if (regNumber.length >= 3) {
            setvehicleRegNo(regNumber)
            dispatch(fetchSearchedVehicleDetail(regNumber))
        } else {
            setvehicleRegNo("")
        }
        return false
    }

    const SearchInput = (fieldRenderProps: FieldRenderProps) => {
        const {name, onChange, value, showContainer} = fieldRenderProps
        const [searchText, setSearchText] = useState(value)

        const onChangeTextField = useCallback(
            (event: InputChangeEvent) => {
                setSearchText(event.value.replace(/\s/g, "").toUpperCase())
                onChange(event)
            },
            [onChange],
        )

        const onFocusTextField = () => {
            showContainer()
        }

        return (
            <Input
                ref={vehRegRef}
                autoComplete={"off"}
                value={searchText}
                name={name}
                onChange={onChangeTextField}
                style={{width: "450px"}}
                id={`search_veh_input`}
                placeholder={"Search vehicle"}
                onFocus={onFocusTextField}
            />
        )
    }

    return (
        <div onFocus={onFocusSchPopover} onBlur={onBlurSchPopover}>
            <div
                className="mb-0"
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "end",
                }}
                ref={anchor}
            >
                <Form
                    onSubmit={searchHandler}
                    initialValues={{vehicleSearch: vehicleRegNo}}
                    key={JSON.stringify({vehicleSearch: vehicleRegNo})}
                    ignoreModified={true}
                    render={(formRenderProps: FormRenderProps) => (
                        <div className="d-flex">
                            <FormElement style={{maxWidth: 450}}>
                                <fieldset className={"k-form-fieldset"}>
                                    <Field
                                        name="vehicleSearch"
                                        showContainer={() => {
                                            setShow(true)
                                        }}
                                        component={SearchInput}
                                    />
                                </fieldset>
                            </FormElement>
                        </div>
                    )}
                />
            </div>
            <Popup
                anchor={anchor.current}
                anchorAlign={{
                    horizontal: "left",
                    vertical: "bottom",
                }}
                popupAlign={{
                    horizontal: "left",
                    vertical: "top",
                }}
                show={show}
                onOpen={onOpenSchPopover}
                onClose={onCloseSchPopover}
                popupClass={["popup-content", "topSearch-height"]}
            >
                <div style={{width: "600px"}}>
                    <WeeklyUtilizationChart showSearchBox={setShow} focusOnSearch={focusOnRegField} />
                    {vehicleRegNo.length > 0 && (
                        <div className="d-flex ">
                            <MotHistoryList
                                vehicleRegNo={vehicleRegNo}
                                showSearchBox={setShow}
                                focusOnSearch={focusOnRegField}
                            />
                            <div className="m-2" style={{width: "10px"}}></div>
                            <RecentBookingsList vehicleRegNo={vehicleRegNo} showSearchBox={setShow} />
                        </div>
                    )}
                </div>
            </Popup>
        </div>
    )
}

export default TopSearchTextField
